var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bubble-container"},[_c('div',{staticClass:"bubble-background"}),_c('div',{staticClass:"bubble-content text-center"},[_vm._t("default",function(){return [_vm._v("Bulle vide")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }